import {
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarExport,
    GridToolbarProps
} from "@mui/x-data-grid";
import { ReactElement } from "react";
import { Box } from "@mui/material";

export interface Props extends GridToolbarProps {
    append?: ReactElement,
    prepend?: ReactElement,
    justify?: 'start' | 'end' | 'center' | 'space-between' | 'space-evenly' | 'space-around',
    align?: 'baseline' | 'center' | 'end' | 'self-start' | 'self-end' | 'stretch',
    fileName?: string,
}

export const BasicGridToolBar = ({ append, prepend, justify, align, fileName, ...props }: Props) => {
    return (
        <GridToolbarContainer sx={{ justifyContent: !!justify ? justify : 'end', alignItems: !!align ? align : 'center' }} {...props}>
            {!!prepend ? prepend : ''}
            <Box sx={{
                ml: !!prepend ? 1 : 0,
                mr: !!append ? 1 : 0,
                display: 'flex',
                alignItems: !!align ? align : 'center'
            }}>
                <GridToolbarColumnsButton size={'medium'} />
                {/* <GridToolbarExport sx={{ml: 1}} size={'medium'} printOptions={{ disableToolbarButton: true }} csvOptions={{
                    fileName: !!fileName ? fileName : undefined,
                    utf8WithBom: true,
                    allColumns: true,
                }} /> */}
                {!!prepend && !!append ? append : ''}
            </Box>
            {!prepend && !!append ? append : ''}
        </GridToolbarContainer>
    )
}

export default BasicGridToolBar;